import { useMutation } from "@tanstack/react-query";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { confirmEmail, ForgetPassword, ForgetPasswordFinish, LogIn, ResendOtp, SignUp } from "~/API/Account";
import type { ConfirmEmailRequest, LoginRequest, ResendOtpRequest, SupplierSignupRequest } from "~/Core/Models";
import type { QueryMutationResult, UserProfileModal } from "~/Store/globals";

const UserInfo = (set, get) => ({
  confirmEmail(): QueryMutationResult<ConfirmEmailRequest> {
    return useMutation({
      mutationFn: confirmEmail,
    });
  },

  ForgetPassword(): QueryMutationResult<ConfirmEmailRequest> {
    return useMutation({
      mutationFn: ForgetPassword,
    });
  },
  ForgetPasswordFinish(): QueryMutationResult<ConfirmEmailRequest> {
    return useMutation({
      mutationFn: ForgetPasswordFinish,
    });
  },

  Login(): QueryMutationResult<LoginRequest> {
    return useMutation({
      mutationFn: LogIn,
      onSuccess(data, _variables) {
        set({ UserProfile: data.data });
      },
    });
  },

  LogOut(): boolean {
    set({ UserProfile: {} });
    localStorage.clear();
    sessionStorage.clear();

    return true;
  },

  ResendOtp(): QueryMutationResult<ResendOtpRequest> {
    return useMutation({
      mutationFn: ResendOtp,
      onSuccess(data, _variables) {
        set({
          UserProfile: { profile: { ...get().UserProfile.profile, ...data.data }, ...get().UserProfile, ...data.data },
        });
      },
    });
  },
  setUserProfile: (UserProfile: UserProfileModal) => {
    set({ UserProfile });
  },

  signup(): QueryMutationResult<SupplierSignupRequest> {
    return useMutation({
      mutationFn: SignUp,
      onSuccess(data, variables) {
        set({ UserProfile: { otpId: data.data.otpId, ...variables } });
      },
    });
  },
  UserProfile: {} as UserProfileModal,
});

export default UserInfo;

const storageVersion = import.meta.env.VITE_STORAGE_VERSION;

export const useAccountStore = create(
  persist(UserInfo, {
    name: "Account",
    storage: createJSONStorage(() => localStorage),
    version: storageVersion,
  }),
);
